import { addSubjectPlaceholder } from './SubjectLine.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47713 */
import ImportanceIcon from './ImportanceIcon';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ITextField, TextField } from 'office-ui-fabric-react/lib/TextField';
import { ControlIcons } from 'owa-control-icons';
import { keydownHandler } from 'owa-hotkeys';
import updateLastFocusedControl from 'owa-mail-compose-actions/lib/actions/updateLastFocusedControl';
import updateSubject from 'owa-mail-compose-actions/lib/actions/updateSubject';
import updateSubjectSelectionRange from 'owa-mail-compose-actions/lib/actions/updateSubjectSelectionRange';
import { ComposeViewState, ComposeControl } from 'owa-mail-compose-store';

import * as React from 'react';
import { DarkModeContext } from 'owa-theme';

const styles = require('./ComposeTop.scss');
const MAX_SUBJECT_LENGTH = 255;

export interface SubjectLineProps {
    composeViewState: ComposeViewState;
}

@observer
export default class SubjectLine extends React.Component<SubjectLineProps, {}> {
    private subjectInput: ITextField;
    static contextType = DarkModeContext;

    render() {
        const {
            subject,
            importance,
            subjectViewState,
            smimeViewState,
        } = this.props.composeViewState;
        const isDarkMode = this.context;

        return (
            <div className={styles.subjectContainer}>
                <div className={styles.subjectIconContainer}>
                    <ImportanceIcon importance={importance} />
                </div>
                <div className={styles.subjectLine}>
                    <TextField
                        id={subjectViewState.inputId}
                        componentRef={(ref: ITextField) => (this.subjectInput = ref)}
                        className={styles.subject}
                        value={subject}
                        inputClassName={isDarkMode && styles.darkModeInput}
                        maxLength={MAX_SUBJECT_LENGTH}
                        borderless={true}
                        autoComplete={'off'}
                        type={'text'}
                        spellCheck={true}
                        placeholder={loc(addSubjectPlaceholder)}
                        ariaLabel={loc(addSubjectPlaceholder)}
                        onChange={this.onSubjectChange}
                        onSelect={this.onSelect}
                        onFocus={this.onSubjectInputFocus}
                    />
                    {smimeViewState && smimeViewState.shouldSignMessageAsSmime && (
                        <Icon iconName={ControlIcons.Ribbon} className={styles.ribbonIcon} />
                    )}
                    {smimeViewState && smimeViewState.shouldEncryptMessageAsSmime && (
                        <Icon iconName={ControlIcons.Lock} className={styles.lockIcon} />
                    )}
                </div>
            </div>
        );
    }

    componentDidUpdate() {
        this.updateSelectionRange();
    }

    updateSelectionRange() {
        const { subjectViewState } = this.props.composeViewState;
        const { selectionStart, selectionEnd } = this.subjectInput;
        if (
            selectionStart != subjectViewState.selectionStart ||
            selectionEnd != subjectViewState.selectionEnd
        ) {
            updateSubjectSelectionRange(this.props.composeViewState, selectionStart, selectionEnd);
        }
    }

    public focus = () => {
        this.subjectInput.focus();
    };

    private onSelect = () => {
        this.updateSelectionRange();
    };

    private onSubjectChange = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue: string
    ) => {
        updateSubject(this.props.composeViewState, newValue);
    };

    private onSubjectInputFocus = () => {
        updateLastFocusedControl(this.props.composeViewState, ComposeControl.SubjectLine);
    };

    @keydownHandler(
        'ctrl+z',
        true /*stopPropagation*/,
        false /*preventDefault*/,
        true /*allowHotkeyOnTextFields*/
    )
    stopUndoPropagation() {
        // do nothing -- this keydown handler stops propagation so that the mailmodule
        // does not eat the undo action & the browser's native Undo functionality can work.
    }
}
